import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

import apiErrorsGerman from "./locale/de/api-errors.json";
import notificationsGerman from "./locale/de/notifications.json";
import translationGerman from "./locale/de/translation.json";

import apiErrorsEnglish from "./locale/en/api-errors.json";
import notificationsEnglish from "./locale/en/notifications.json";
import translationEnglish from "./locale/en/translation.json";

import apiErrorsSpanish from "./locale/es/api-errors.json";
import notificationsSpanish from "./locale/es/notifications.json";
import translationSpanish from "./locale/es/translation.json";

import apiErrorsFrench from "./locale/fr/api-errors.json";
import notificationsFrench from "./locale/fr/notifications.json";
import translationFrench from "./locale/fr/translation.json";

import apiErrorsItalian from "./locale/it/api-errors.json";
import notificationsItalian from "./locale/it/notifications.json";
import translationItalian from "./locale/it/translation.json";

const resources = {
	en: {
		translation: translationEnglish,
		notifications: notificationsEnglish,
		apiErrors: apiErrorsEnglish,
	},
	it: {
		translation: translationItalian,
		notifications: notificationsItalian,
		apiErrors: apiErrorsItalian,
	},
	fr: {
		translation: translationFrench,
		notifications: notificationsFrench,
		apiErrors: apiErrorsFrench,
	},
	de: {
		translation: translationGerman,
		notifications: notificationsGerman,
		apiErrors: apiErrorsGerman,
	},
	es: {
		translation: translationSpanish,
		notifications: notificationsSpanish,
		apiErrors: apiErrorsSpanish,
	},
};

i18n
	// load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
	// learn more: https://github.com/i18next/i18next-http-backend
	.use(Backend)
	// detect user language
	// learn more: https://github.com/i18next/i18next-browser-languageDetector
	.use(LanguageDetector)
	// pass the i18n instance to react-i18next
	.use(initReactI18next)
	// init i18next
	// for all options read: https://www.i18next.com/overview/configuration-options
	.init({
		resources: resources,
		fallbackLng: "en",
		debug: true,

		interpolation: {
			escapeValue: false, // not needed for react as it escapes by default
		},
	});

export default i18n;
